/* eslint-disable import/prefer-default-export */
// @flow
import { ApiBase } from 'api/api'
import { makePostRequest } from 'api/fetchCalls'
import type { UpdateResponseQueue } from 'types/response_queue'

export async function updateResponseQueue(
  data: UpdateResponseQueue
): Promise<{ message: string }> {
  return makePostRequest(`${ApiBase}/response_queue`, {
    body: JSON.stringify(data),
  })
}
